import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "bg_white m-20",
  style: {
    "margin-bottom": "70px"
  }
};
const _hoisted_2 = {
  class: "wrap text-black p-t-20 p-b-20 p-l-40 p-r-40"
};
const _hoisted_3 = {
  class: "basic_info"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "others"
};
const _hoisted_7 = {
  class: "bg_white m-t-10 p-l-20 p-r-20 p-t-10 p-b-10 text-black footer",
  style: {
    "width": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("main", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
    ref: "form",
    model: $data.form,
    rules: $data.rules,
    "label-width": "120px",
    class: "m-t-20",
    "label-position": "left"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[25] || (_cache[25] = _createElementVNode("h3", null, "基础信息", -1)), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "编码",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.id = $event),
            style: {
              "width": "60%"
            },
            disabled: "true",
            placeholder: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "专利名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.name = $event),
            placeholder: "请输入产品名称及型号",
            style: {
              "width": "60%"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请进度",
          prop: "progress"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.progress,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.progress = $event),
            placeholder: "请选择申请进度",
            onChange: $options.changeProgress
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.progress, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "项目负责人",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.adminIds, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [_createVNode(_component_el_cascader, {
              modelValue: item.dept,
              "onUpdate:modelValue": $event => item.dept = $event,
              options: $data.deptData,
              props: {
                expandTrigger: 'hover',
                value: 'dept_code',
                label: 'dept_name',
                children: 'children'
              },
              onChange: $options.changeDept
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]), _createVNode(_component_el_select, {
              modelValue: item.user,
              "onUpdate:modelValue": $event => item.user = $event,
              multiple: "",
              placeholder: "请选择项目负责人",
              filterable: "",
              onChange: $options.selAdmin
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.adminData, (item1, index1) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index1,
                  label: item1.staff_name,
                  value: item1.staff_code
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]), _createElementVNode("i", {
              class: "el-icon-delete m-l-10",
              onClick: $event => $options.deleteClick(item, index)
            }, null, 8, _hoisted_4)], 64);
          }), 128)), _createElementVNode("i", {
            class: "el-icon-circle-plus-outline m-l-10",
            onClick: _cache[3] || (_cache[3] = (...args) => $options.addAdmin && $options.addAdmin(...args))
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请人",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.applyIds, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [_createVNode(_component_el_cascader, {
              modelValue: item.dept,
              "onUpdate:modelValue": $event => item.dept = $event,
              options: $data.deptData1,
              props: {
                expandTrigger: 'hover',
                value: 'dept_code',
                label: 'dept_name',
                children: 'children'
              },
              onChange: $options.changeDept1
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]), _createVNode(_component_el_select, {
              modelValue: item.user,
              "onUpdate:modelValue": $event => item.user = $event,
              multiple: "",
              placeholder: "请选择申请人",
              filterable: "",
              onChange: $options.selApply
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applyData, (item1, index1) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index1,
                  label: item1.staff_name,
                  value: item1.staff_code
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]), _createElementVNode("i", {
              class: "el-icon-delete m-l-10",
              onClick: $event => $options.deleteClick1(item, index)
            }, null, 8, _hoisted_5)], 64);
          }), 128)), _createElementVNode("i", {
            class: "el-icon-circle-plus-outline m-l-10",
            onClick: _cache[4] || (_cache[4] = (...args) => $options.addApply && $options.addApply(...args))
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "专利类型",
          prop: "patent_type_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.patent_type_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.patent_type_id = $event),
            placeholder: "请选择专利类型",
            onChange: $options.changePatent
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.patentType, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "价值级别",
          prop: "worth_level"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.worth_level,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.worth_level = $event),
            placeholder: "请选择价值级别",
            onChange: $options.changeWorth
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.worthLevel, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请主体",
          prop: "org_ids"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.org_ids,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.org_ids = $event),
            placeholder: "请输入公司名称",
            style: {
              "width": "60%"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "是否涉及国外",
          prop: "is_outcountry"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.form.is_outcountry,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.is_outcountry = $event),
            placeholder: "请选择是否涉及国外",
            onChange: $options.changeArea
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.outcountry, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请国家",
          prop: "apply_country"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.apply_country,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.apply_country = $event),
            placeholder: "多个国家间用“，”隔开",
            style: {
              "width": "60%"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品简介",
          prop: "production_desc"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            maxlength: "100",
            "show-word-limit": "",
            type: "textarea",
            placeholder: "请输入产品简介",
            modelValue: $data.form.production_desc,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.production_desc = $event),
            style: {
              "width": "60%"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品图片",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            ref: "upload",
            action: $options.api_upload_url,
            "list-type": "picture-card",
            name: "img",
            "with-credentials": true,
            "on-success": $options.handlePhotoSuccess,
            "on-preview": $options.handlePhotoPreview,
            limit: 1,
            "on-remove": $options.handlePhotoRemove,
            accept: ".jpg,.png",
            "on-exceed": $options.handleExceed,
            "file-list": $data.imgList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "text"
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("i", {
                class: "el-icon-plus"
              }, null, -1)])),
              _: 1,
              __: [21]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "on-exceed", "file-list"]), _cache[22] || (_cache[22] = _createElementVNode("div", {
            class: "el-upload__tip f_12 l_height_25"
          }, "支持png、jpg格式, 上限1M", -1)), _createVNode(_component_el_dialog, {
            modelValue: $data.dialogVisible,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.dialogVisible = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              width: "100%",
              src: $data.dialogImageUrl,
              alt: ""
            }, null, 8, ["src"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1,
          __: [22]
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "技术交底书",
          prop: "",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "upload-demo",
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": $options.handleSuccess,
            "on-preview": _ctx.handlePreview,
            "on-remove": $options.handleRemove,
            "before-upload": $options.fileUpload,
            limit: 1,
            accept: ".pdf, .xlsx, .docx, .doc, .xls",
            "file-list": $data.fileList
          }, {
            tip: _withCtx(() => _cache[24] || (_cache[24] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持PDF、Word、Excel格式，限10M内 ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("上传")])),
              _: 1,
              __: [23]
            })]),
            _: 1
          }, 8, ["action", "on-success", "on-preview", "on-remove", "before-upload", "file-list"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("h3", null, "查询结果", -1)), _createVNode(_component_el_radio_group, {
          modelValue: $data.form.checkout_result,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.checkout_result = $event),
          onChange: $options.changeSearch
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkData, (item, index) => {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: index,
              label: item.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1,
        __: [26]
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("h3", null, "申请结果", -1)), _createVNode(_component_el_radio_group, {
          modelValue: $data.form.apply_result,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.form.apply_result = $event),
          onChange: $options.changeApply
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.applyData, (item, index) => {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: index,
              label: item.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1,
        __: [27]
      })]),
      _: 1
    }), _cache[28] || (_cache[28] = _createElementVNode("h3", null, "时间进度", -1)), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "申请时间",
          prop: "apply_time"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: $data.form.apply_time,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.form.apply_time = $event),
            type: "date",
            placeholder: "请选择申请时间",
            "value-format": "YYYY-MM-DD",
            onChange: $options.changeApplyTime
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "公告时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: $data.form.publish_time,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.form.publish_time = $event),
            type: "date",
            placeholder: "请选择公告时间",
            "value-format": "YYYY-MM-DD",
            onChange: $options.changePublishTime
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "续费时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: $data.form.renewals_time,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.form.renewals_time = $event),
            type: "date",
            placeholder: "请选择续费时间",
            "value-format": "YYYY-MM-DD",
            onChange: $options.changeRenewalsTime
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _cache[29] || (_cache[29] = _createElementVNode("h3", null, "费用信息", -1)), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "单价",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.price,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.form.price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限数字，支持小数",
            onChange: $options.changePrice
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "数量",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.num,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.form.num = $event),
            style: {
              "width": "60%"
            },
            placeholder: "仅限正整数",
            onChange: $options.changeNum
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "总计",
          prop: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.form.total_price,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.form.total_price = $event),
            style: {
              "width": "60%"
            },
            placeholder: "",
            disabled: "true"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model", "rules"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
    type: "primary",
    class: "search_button",
    onClick: _cache[20] || (_cache[20] = $event => $options.submitClick('form'))
  }, {
    default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("提交")])),
    _: 1,
    __: [30]
  })])]);
}